export const positionKeys = [
    'LF', 'CF', 'RF', 'SS', '2B', '1B', '3B', 'C', 'DH', 
    'SUB1', 'SUB2', 'SUB3', 'SUB4', 'SUB5', 'SUB6', 
    'SP1', 'SP2', 'SP3', 'SP4', 'SP5', 
    'RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6', 'CP'
]

export const batterKeys = [
    'LF', 'CF', 'RF', 'SS', '2B', '1B', '3B', 'C', 'DH', 
    'SUB1', 'SUB2', 'SUB3', 'SUB4', 'SUB5', 'SUB6'
]

export const pitcherKeys = [
    'SP1', 'SP2', 'SP3', 'SP4', 'SP5', 
    'RP1', 'RP2', 'RP3', 'RP4', 'RP5', 'RP6', 'CP'
]

export const selectionBatterPositionKeys = [
    'LF', 'CF', 'RF', 'SS', '2B', '1B', '3B', 'C', 'DH', 
]

export const stateKeys = ['s1', 's2', 's3', 's4', 's5', 's6'];

export const dreamTeamKeys = ['두산', 'KT', 'SSG', '삼성', '롯데']

export const nanumTeamKeys = ['KIA', '한화', 'NC','키움', 'LG']

export const teamKeys = ['두산', 'KT', 'SSG', '삼성', '롯데', 'KIA', '한화', 'NC', '키움', 'LG']

export const yearKeys = ['82', '83', '84', '85', '86', '87', '88', '89', '90', '91', 
    '92', '93', '94', '95', '96', '97', '98', '99', '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
     '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25']

export const needSelectionType = ["Team", "YearPosition", "TeamCardType", "TeamPosition"]

export const lineupKeys = ['1번', '2번', '3번', '4번', '5번', '6번', '7번', '8번', '9번']
